import { Component, OnInit, TemplateRef, Inject, HostListener, ViewChild, Injectable, SimpleChanges, ElementRef, ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import { Observable, Subscription, combineLatest } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router, NavigationEnd, ActivationEnd, ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot, CanDeactivate, NavigationStart } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Track } from 'ngx-audio-player';
import { PlatformLocation } from '@angular/common';
import { VgAPI, VgControlsHidden } from 'videogular2/core';
import { Location } from '@angular/common';
import { Meta, MetaDefinition, Title } from "@angular/platform-browser";
declare var jQuery: any;
import { Gallery, GalleryItem, ImageItem, ThumbnailsPosition, ImageSize, CounterPosition, LoadingStrategy } from '@ngx-gallery/core';
import { LIGHTBOX_CONFIG, Lightbox, LightboxComponent, LightboxModule, LightboxConfig } from "@ngx-gallery/lightbox";
import { faPlay, faPause } from '@fortawesome/free-solid-svg-icons';
import { SearchCountryField, TooltipLabel, CountryISO } from "ngx-intl-tel-input";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEnvelope, faEllipsisH, faCommentAlt, faLink, faPrint, faMinus, faCheck, faShare } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faTwitter, faLinkedinIn, faWhatsapp, faGooglePlusG, faPinterestP, faFacebookMessenger, faTelegramPlane, faTumblr, faVk, faRedditAlien, faMix, faXing, faLine } from '@fortawesome/free-brands-svg-icons';
import { NgNavigatorShareService } from 'ng-navigator-share';
import { MusicService } from "src/app/services/music.service";
import { LocationService } from "src/app/services/location.service";
import { UnlServiceService } from "src/app/services/unl-service.service";
import { UnlAdsService } from "src/app/services/unl.ads.service";
import { FsDocument, FsDocumentElement } from "src/app/interfaces/fullscreen.type";
import { ShareService } from "src/app/services/share-service.service";
import { AuthService } from "src/app/services/auth.service";
import { AdType } from "../../desktop-ad/desk-ad-type";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-description-content",
  templateUrl: "./description-content.component.html",
  styleUrls: ["./description-content.component.scss"]
})
@Injectable({ providedIn: 'root' })
export class DescriptionContentComponent implements OnInit {
  @ViewChild('rsvpforms') formsTemplate: TemplateRef<any>;
  @ViewChild('template') videoTemplate: TemplateRef<any>;
  @ViewChild('musicModal') musicTemplate: TemplateRef<any>;
  isdesktop = environment.isMoblie === false;
  isLoginModalOpen = false;
  faPlay = faPlay;
  faPause = faPause;
  frmtype;
  descriptions;
  desc_Path;
  descCurrentnodeId;
  descDetails;
  otherdetailsarray;
  otherdetailtypedetail;
  addedByarray;
  fromtime;
  totime;
  type;
  modalRef: BsModalRef;
  albumsLightbox;
  albumbkey = [];
  discVid;
  cArr;
  Vtitle;
  head_Img;
  descFormsBtns;
  dialcodeJson;
  descNID;
  thumbnail = [];
  Btntype: any;
  // firstcontentWidth: number;
  // firstcontentTop: number;
  scrollableH;
  posts: FormGroup;
  msaapDisplayTitle = true;
  msaapDisplayPlayList = true;
  msaapPageSizeOptions = [3, 6, 9];
  msaapPlaylist: Track[] = [];
  moreDetailsArray = [];
  adJson;
  adJsonContent: any = [];
  adContent: any;
  cType;
  termId;
  respVal;
  isModalOpen = true;
  overLayT: boolean = false;
  isPortrait = true;
  conPP: boolean;
  vidtitle;
  subscriptions: Subscription[] = [];
  config = {
    class: 'modal-sm modalsizecls',
    ignoreBackdropClick: false
  }
  submitted = false;
  unlRsvpForm1 = new FormGroup({
    date: new FormControl('', Validators.required),
    firstName: new FormControl('', Validators.required),
    lastName: new FormControl('', Validators.required),
    eMail: new FormControl('', Validators.required),
    phone: new FormControl(undefined, [Validators.required]),
    noofGuests: new FormControl('', Validators.required),
    posts: new FormControl('Yes'),
    comment: new FormControl(''),
    node_id: new FormControl(''),
    node_title: new FormControl(''),
    node_type: new FormControl('')
  });
  days: any;
  frmcopy: FormGroup;
  rate: number;
  caption = jQuery(this).data('caption') || '';
  photos = []
  items: GalleryItem[];
  isLightbxclsd;
  today = new Date();
  dates: string[] = [];
  @ViewChild('lightbox') lightbox;
  @ViewChild('lightboxTitle') Lightboxtitle;
  twindow = window as any;
  missing: any[];
  adImp: any[];
  head_Vid: string;
  api: VgAPI;
  api2: VgAPI;
  artist: any;
  x: any;
  head_Img_like: string;
  titleW;
  slicer;
  descbtns: string;
  descpara: any;
  descsubscription: any;
  pagehead = 'All';
  menudata;
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  TooltipLabel = TooltipLabel;
  CountryISO = CountryISO;
  preferredCountries: any[] = []; //[CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  metakeys;
  currenturl;
  sharebody;
  sharelink;
  sharetext;
  metaimg;
  datadomain: string = "";
  screenHeight: any = {height:"700px"};
  loaderH: number;
  ismuted: boolean=false;
  _iOSDevice:boolean=false;
  _iOSDevice1:boolean = false;
  ismuted1:boolean = false;
  autoplayboolean = true;
  isModalOpen1: boolean = false;
  videoForCpDc: any = null;
  pauseAd: boolean = false;
  descpara1: any;
  descpara2: any;
  AdType = AdType;
  constructor(
    private locationService: LocationService,
    private http: HttpClient,
    private unlServiceService: UnlServiceService,
    private modalService: BsModalService,
    private unlAdsService: UnlAdsService,
    private router: Router,
    private formBuilder: FormBuilder,
    private location: PlatformLocation,
    private changeDetection: ChangeDetectorRef,
    private controlsHidden: VgControlsHidden,
    private location2: Location,
    private title: Title,
    private meta: Meta,
    private fb: FormBuilder,
    public gallery: Gallery,
    private musicService: MusicService,
    private shareService: ShareService,
    private ngNavigatorShareService: NgNavigatorShareService,
    private authService: AuthService,
    private route: ActivatedRoute,
    public lightBoxRef: Lightbox) {
    this.datadomain = this.unlServiceService.basepath;
    library.add(faShare, faEnvelope, faFacebookF, faLinkedinIn, faTwitter, faWhatsapp, faGooglePlusG, faPinterestP, faFacebookMessenger, faTelegramPlane, faTumblr, faVk, faRedditAlien, faMix, faEllipsisH, faCommentAlt, faLink, faPrint, faMinus, faXing, faLine, faCheck);
    location.onPopState(() => this.closeModal());
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.descsubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        //$("#pageloader").show();
      }
      if (event instanceof ActivationEnd) {
        this.descNID = event.snapshot.params.nodeId;
        this.cType = event.snapshot.params.ctype;
        this.termId = event.snapshot.params.termid;
        this.ngNavigatorShareService = ngNavigatorShareService;
        if (this.descNID !== undefined) {
          this.descCurrentnodeId = this.descNID;
          this.moreDetailsArray = [];
          this.loadDescPage();
        }
        this.adImp = [];
      }
    });
  }
  scrollToElement($element): void {
    localStorage.setItem("scrollPosition", '0');
    window.scrollTo(0, 0);
   // alert('okk');
    //$element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  }
  openModal12(e: any) {
    this.videoForCpDc = e.videos[0].url;
    console.log( this.videoForCpDc);
    this.isModalOpen1 = true;
  }

  closeModal12() {
    this.isModalOpen1 = false;
  }

  ngOnInit() {
    localStorage.setItem("scrollPosition", '0');
    window.scrollTo(0, 0);
    // var wW = screen.width;
    // var leftsidenavwidth = $(".sidenavmat").outerWidth(true);
    // this.firstcontentWidth = wW - leftsidenavwidth;
    // var headerHeight = $("#fixedheader").outerHeight(true);
    // var titleH = $(".fixedtitle").innerHeight();
    // if(titleH !=undefined)
    //   this.firstcontentTop = headerHeight+titleH;
    // else
    //   this.firstcontentTop = headerHeight+26;
    this.getScreenSize();
    this.getDialJson();
    LightboxModule.withConfig({
      panelClass: 'fullscreen'
    })
    this.twindow.my = {};
    this.twindow.my.unlvideo = this.twindow.my.unlvideo || {};
    this.twindow.my.unlvideo.toggleScrn = this.setFullScreen.bind(this);
    try {
      jQuery('.owl-carousel4').owlCarousel({
        startPosition: 1,
        dots: false,
        items: 4
      });
    } catch (e) {
      console.log(e);
    }

  }
  images = [];
  videos = [];
  getDescPageUrl(): Observable<any> {
    this.descCurrentnodeId = this.locationService.setIndex();
    if (this.descCurrentnodeId = "undefined") {
      this.descCurrentnodeId = this.descNID;
    }
    var url=this.unlServiceService.nodeurl +
    this.descCurrentnodeId +
    this.unlServiceService.desc_Page;
    url = this.unlServiceService.updateURLParameter(url,"img_preset2",this.unlServiceService.img_preset);
    url = this.unlServiceService.updateURLParameter(url,"img_preset3","service_default");
    return this.http.get(url);
  }
  getDescId(i) {
    this.items = []
    this.thumbnail = [];
    this.videos = [];
    this.images = [];
    this.descCurrentnodeId = this.moreDetailsArray[0].val[i].nid;
    this.getDescPageUrl();
  }
  getDescVidUrl(): Observable<any> {
    return this.http.get(
      this.unlServiceService.desc_Videos + this.descCurrentnodeId
    );
  }
  loadDescPage() {
    this.getScreenSize();
    this.getDescPageUrl().subscribe(descData => {
      
      if (!descData) {
        return;
      }

      if (descData.type == "restaurants")
        this.days = descData.field_restaurents_days;
      else if (descData.type == "bars")
        this.days = descData.field_bars_days;
      else
        this.days = descData.field_nightclubs_days;
      var dayslist = [];
      console.log(descData, "nnnndddddddddd");
      if (this.days !== undefined) {
        for (var i = 0; i < this.days.length; i++) {
          dayslist.push(parseInt(this.days[i].value));
        }
        var a = [1, 2, 3], count = 5;
        this.missing = new Array();
        for (var i = 0; i <= count; i++) {
          if (dayslist.indexOf(i) == -1) {
            this.missing.push(i);
          }
        }
      }

      if (descData.voting_results.length !== 0) {
        for (var i = 0; i < descData.voting_results.length; i++) {
          if (descData.voting_results[i].function == "average") {
            var ratePercent: number = parseFloat(descData.voting_results[i].value);
            this.rate = ratePercent / 100 * 5;
          } else {
            this.rate = 0;
          }
        }
      } else {
        this.rate = 0
      }
      if (descData.type !== "news" && descData.type !== "fashion_store" && descData.type !== "video1" && descData.type !== "video_live" && descData.type !== "movies" && descData.type !== "photos") {
        this.descbtns = descData[this.unlServiceService.descbuttons[descData.type]][0].value;
      }
      else {
        this.descbtns = "not"
      }
      //this.descpara = JSON.stringify(descData.body).replace(/(?:\\[rn])+/g, '<p class="pcls"></p>');
      this.descpara = JSON.stringify(descData.body).replace(/(?:\\[rn])+/g, '<p class="pcls"></p>');
      this.descpara = this.descpara.replace(/\"/g, "");
      this.splitDescription();
      this.otherdetailtypedetail = this.unlServiceService.typeDetailsLabel[descData.type];
      if (this.otherdetailtypedetail !== undefined)
        this.otherdetailtypedetail["val"] = this.unlServiceService.getotherdetailtype(descData.taxonomy, this.otherdetailtypedetail);
      this.otherdetailsarray = this.unlServiceService.locationDetailsLabel[descData.type];
      this.albumbkey = this.unlServiceService.albumbkey[descData.type];
      if (descData.type.toLowerCase() !== "news") {
        if (descData.type.toLowerCase() == "photos" || descData.type.toLowerCase() == "videos" || descData.type.toLowerCase() == "video_live") {
          this.addedByarray = this.unlServiceService.contactName[descData.type][0].key;
        } else if (this.otherdetailsarray !== undefined) {
          for (var i = 0; i < this.otherdetailsarray.length; i++) {
            if (descData[this.otherdetailsarray[i].key] == undefined) {
              this.otherdetailsarray[i].key[i];
            }
          }
          this.fromtime = this.otherdetailsarray[1].key[0];
          this.totime = this.otherdetailsarray[1].key[1];
          this.addedByarray = this.unlServiceService.contactName[descData.type][0].key;
        }
      } else {
        this.addedByarray = this.unlServiceService.contactName["news"][0].key;
      }
      if (descData.type == 'concerts' || descData.type == 'event' || descData.type == 'fashion') {
        var dates: [] = descData["field_" + descData.type + "_time"];
        if (dates.length !== 0) {
          var curdate = new Date().getTime();
          var futuredates = [];
          for (var i = 0; i <= dates.length - 1; i++) {
            var DateTime = descData["field_" + descData.type + "_time"][i].value;
            // var str = DateTime.Now.toDateString();
            var ts = new Date(DateTime);
            if (ts.getTime() >= curdate) {
              futuredates.push(descData["field_" + descData.type + "_time"][i]);
              this.dates.push(ts.toLocaleDateString());
            }
          }
          if (futuredates.length == 0) {
            var latdate = descData["field_" + descData.type + "_time"].length - 1;
            futuredates.push(descData["field_" + descData.type + "_time"][latdate]);
          }
          descData["field_" + descData.type + "_time"] = futuredates;
          // var temp = this.dates.map(d => Math.abs(new Date().getTime() - new Date(d).getTime()));
          // var idx = temp.indexOf(Math.min(...temp));
          // var nearest = require('nearest-date');
          // var index = nearest(this.dates, this.today);
        }

      }

      this.type = descData.taxonomy[Object.keys(descData.taxonomy)[0]].name;
      this.artist = descData.taxonomy[Object.keys(descData.taxonomy)[Object.keys(descData.taxonomy).length - 1]].name;
      this.desc_Path = descData.path;
      this.locationService.getDescPath(this.desc_Path);
      this.descriptions = descData;
      this.descriptions.conPP = this.conPP;
      this.descriptions.overLayT = this.overLayT;
      this.unlRsvpForm1.get('node_id').setValue(this.descriptions.nid);
      this.unlRsvpForm1.get('node_title').setValue(this.descriptions.title);
      this.unlRsvpForm1.get('node_type').setValue(this.descriptions.type);
      if (descData.type == "hotel") {
        this.unlRsvpForm1.addControl('checkout', new FormControl('', Validators.required));
      }
      if (descData.type == "restaurants") {
        this.unlRsvpForm1.addControl('time', new FormControl('', Validators.required));
      }
      for (var i = 0; i < this.unlServiceService.menus.length; i++) {
        if (this.descriptions.type == "video_live") {
          var desctype = 'video1';
        } else if (this.descriptions.type == "fashion") {
          var desctype = 'fashion_store';
        } else if (this.descriptions.type == "event") {
          var desctype = 'events';
        } else {
          var desctype = '' + descData.type;
        }

        if (desctype === this.unlServiceService.menus[i].ctype) {
          var tabs = this.unlServiceService.menus[i].tabs;
          this.pagehead = this.unlServiceService.menus[i].title;
          this.menudata = this.unlServiceService.menus[i];
          if (this.pagehead != 'ALL' && i != 0)
            $("#toptitle").html(this.pagehead);
          if ($('.aligner1 .active').text() == 'ALL') {
            $('.aligner1 li').first().removeClass('active');
            $('.aligner1 li:nth-child(' + (i + 1) + ')').addClass('active');
          }
          for (var j = 0; j < tabs.length; j++) {
            var morecontent = 'No';
            if (desctype == 'fashion_store') {
              if (descData.type == "fashion" && tabs[j].title == "More Upcoming Fashion Events")
                morecontent = 'Yes';
              else if (descData.type == "fashion_store" && tabs[j].title == "More Fashion Stores & Boutiques")
                morecontent = 'Yes';
            } else {
              if (tabs[j].title.includes("More"))
                morecontent = 'Yes';
            }

            if (morecontent == 'Yes') {
              var title = tabs[j].title;
              if (!this.termId)
                this.termId = tabs[j].url.split('cit=')[1];
              if (!tabs[j].url.includes("cit=")) {
                tabs[j].url = this.unlServiceService.updateURLParameter(tabs[j].url, "cit", this.termId);
              } else {
                tabs[j].url = this.unlServiceService.updateURLParameter(tabs[j].url, "cit", this.termId);
              }
              this.http.get(tabs[j].url + this.unlServiceService.image_preset).subscribe(val => {
                this.respVal = val;
                var moreDetailsArray = [];
                for (var i = 0; i < this.respVal.length; i++) {
                  if (this.htmlDecode(this.respVal[i].title) == this.descriptions.title || this.htmlDecode(this.respVal[i].node_title) == this.descriptions.title) {
                    if (i < 3) {
                      this.slicer = 3;
                    } else if (i >= 3) {
                      this.slicer = 2;
                    }
                  }
                  if (this.respVal[i].type == "videos live" && this.respVal[i].image_cache.split('service_mobile1/')[1] == '') {
                    this.respVal[i].image_cache = this.respVal[i].image_cache + this.respVal[i].live_video_thumb.split('files/')[1];
                  }
                }
                moreDetailsArray.push({ val: this.respVal, title: title });
                if (this.slicer == undefined) {
                  this.slicer = 2;
                }
                this.moreDetailsArray = moreDetailsArray;
              });
            }
          }
        }
      }
      this.metadatadesc(this.menudata);
      if (this.descriptions[this.unlServiceService.descimgpath[descData.type]][0].filepath !== null) {
        if (descData.type == "video1") {
          this.head_Img = this.descriptions.image_cache_path.replace('desc_tab', 'mobile_videodesc');
          if (this.head_Img !== undefined) {
            if (descData.field_video !== undefined) {
              if (descData.converted_videos.sd_mp4 != null) {
                const parts = descData.converted_videos.sd_mp4.split('https://');
                console.log('Split URL:', parts)
                const httpsCount = parts.length - 1;
                if(httpsCount > 1) {
                  this.head_Vid = 'https://' + parts.slice(2).join('https://');
                  console.log('Fixed URL:', this.head_Vid)
                } else if(httpsCount == 0) {
                  this.head_Vid = this.unlServiceService.basepath + descData.converted_videos.sd_mp4;
                  console.log('URL with basepath:', this.head_Vid)
                } else {
                  this.head_Vid = descData.converted_videos.sd_mp4;
                  console.log('URL:', this.head_Vid)
                }
                // if(descData.converted_videos.sd_mp4.startsWith('https://cdn.nightlife.net/')) {
                //   this.head_Vid = descData.converted_videos.sd_mp4;
                // } else {
                //   this.head_Vid = this.unlServiceService.basepath + descData.converted_videos.sd_mp4;
                // }
              } else {
                const parts = descData.converted_videos.hd_mp4.split('https://');
                console.log('Split URL:', parts)
                const httpsCount = parts.length - 1;
                if(httpsCount > 1) {
                  this.head_Vid = 'https://' + parts.slice(2).join('https://');
                  console.log('Fixed URL:', this.head_Vid)
                } else if(httpsCount == 0) {
                  this.head_Vid = this.unlServiceService.basepath + descData.converted_videos.hd_mp4;
                  console.log('URL:', this.head_Vid)
                } else {
                  this.head_Vid = descData.converted_videos.hd_mp4;
                  console.log('URL:', this.head_Vid)
                }
                // if(descData.converted_videos.hd_mp4.startsWith('https://cdn.nightlife.net/')) {
                //   this.head_Vid = descData.converted_videos.hd_mp4;
                // } else {
                //   this.head_Vid = this.unlServiceService.basepath + descData.converted_videos.hd_mp4;
                // }
              }
            }
          }
        } else if (descData.type == 'video_live') {
          var splitedlive = this.descriptions.field_thumbnail[0].filepath.split('files/');
          this.head_Img = this.descriptions.image_cache_path.replace('desc_tab', 'mobile_videodesc') + splitedlive[1];
          if (this.head_Img !== undefined) {
            if (descData.field_live_video !== undefined) {
              this.head_Vid = descData.field_live_video[0].value;
            }
          }
        } else {
          this.head_Img = this.descriptions.image_cache_path;
          if (this.head_Img !== undefined) {
            if (this.head_Img.match(/\.(jpeg|jpg|gif|png)$/) == null) {
              this.head_Img_like = this.unlServiceService.basepath + this.descriptions[this.unlServiceService.descimgpath[descData.type]][0].filepath;
              var splited = this.head_Img_like.split('files/');
              this.head_Img = splited[0] + 'files/imagecache/desc_tab/' + splited[1];
            }
          } else {
            if (descData.type == "photos") {
              this.head_Img = this.descriptions.image_album_path.full[0].replace('service_default', 'photos_desc_mobile');
            } else {
              this.head_Img = this.descriptions.image_album_path.full[0];
            }
          }

          // ;
        }
        this.images = [];
        if (descData.type == "photos") {
          for (var j = 0; j < descData.field_upload_photo.length; j++) {
            var srcurl2 = this.unlServiceService.basepath + descData.field_upload_photo[j].filepath;
            srcurl2 = srcurl2.replace('default/files/', 'default/files/imagecache/mobile_photoslide/');
            this.images.push({
              srcUrl: srcurl2,
              previewUrl: descData.image_album_path.thumb[j]
            });
          }
        } else if (descData[this.unlServiceService.albumbkey[descData.type]] !== undefined && descData.image_album_path.thumb !== undefined) {
          for (var j = 0; j < descData[this.unlServiceService.albumbkey[descData.type]].length; j++) {
            var srcurl = descData[this.unlServiceService.albumbkey[descData.type]][j].filepath;
            srcurl = srcurl.replace('default/files/', 'default/files/imagecache/mobile_photoslide/');
            this.images.push({
              srcUrl: this.unlServiceService.basepath + srcurl,
              previewUrl: descData.image_album_path.thumb[j]
            });
          }
        } else if (descData[this.unlServiceService.albumbkey[descData.type]] !== undefined && descData[this.unlServiceService.albumbkey[descData.type]][0] !== null) {
          for (var j = 0; j < descData[this.unlServiceService.albumbkey[descData.type]].length; j++) {
            var prevurl = descData[this.unlServiceService.albumbkey[descData.type]][j].filepath;
            var srcurl = prevurl.replace('default/files/', 'default/files/imagecache/mobile_photoslide/');
            prevurl = prevurl.replace('default/files/', 'default/files/imagecache/service_tabs1/');
            this.images.push({
              srcUrl: this.unlServiceService.basepath + srcurl,
              previewUrl: this.unlServiceService.basepath + prevurl
            });
          }
        }
      }
      this.items = this.images.map(item =>
        new ImageItem({ src: item.srcUrl, thumb: item.previewUrl })
      );
      try {
        jQuery('.owl-carousel4').owlCarousel({
          startPosition: 1,
          dots: false,
          items: 4
        });
      } catch (e) {
        console.log(e);
      }
      try {
        jQuery('.owl-carousell').owlCarousel({
          startPosition: 1,
          dots: false,
          items: 4
        });
      } catch (e) {
        console.log(e);
      }
      this.checkMplayer();
    },
      () => { },
      () => {

        setTimeout(function () {
          this.titleW = $("#scrble").outerHeight(true);
          this.scrollablecontentH = this.titleW + 3;
          // $("#pageloader").fadeOut();
          //$(".ng-sidebar__content").scrollTop(0);
        }, 300);

        //jQuery.when(this.getScreenSize()).done();
      });
    this.videos = [];
    //if(this.descriptions.type !='video1' && this.descriptions.type !='video_live' && this.descriptions.type !='photos')
    this.getDescVidUrl().subscribe(vid_Response => {
      this.discVid = vid_Response;
      for (var i = 0; i < vid_Response.length; i++) {
        if (vid_Response[i].converted_videos.sd_mp4 != null) {
          const parts = vid_Response[i].converted_videos.sd_mp4.split('https://');
          console.log('Split URL:', parts)
          const httpsCount = parts.length - 1;
          if(httpsCount > 1) {
            var vidurl = 'https://' + parts.slice(2).join('https://');
            console.log('Fixed URL:', vidurl)
          } else if(httpsCount == 0) {
            var vidurl = this.unlServiceService.basepath + vid_Response[i].converted_videos.sd_mp4;
            console.log('URL with basepath:', vidurl)
          } else {
            var vidurl: string = vid_Response[i].converted_videos.sd_mp4;
            console.log('URL:', vidurl)
          }
          // if(vid_Response[i].converted_videos.sd_mp4.startsWith('https://cdn.nightlife.net/')) {
          //   var vidurl: string = vid_Response[i].converted_videos.sd_mp4;
          // } else {
          //   var vidurl = this.unlServiceService.basepath + vid_Response[i].converted_videos.sd_mp4;
          // }
        } else {
          const parts = vid_Response[i].converted_videos.hd_mp4.split('https://');
          console.log('Split URL:', parts)
          const httpsCount = parts.length - 1;
          if(httpsCount > 1) {
            var vidurl = 'https://' + parts.slice(2).join('https://');
            console.log('Fixed URL:', vidurl)
          } else if(httpsCount == 0) {
            var vidurl = this.unlServiceService.basepath + vid_Response[i].converted_videos.hd_mp4;
            console.log('URL:', vidurl)
          } else {
            var vidurl: string = vid_Response[i].converted_videos.hd_mp4;
            console.log('URL:', vidurl)
          }
          // if(vid_Response[i].converted_videos.hd_mp4.startsWith('https://cdn.nightlife.net/')) {
          //   var vidurl: string = vid_Response[i].converted_videos.hd_mp4;
          // } else {
          //   var vidurl = this.unlServiceService.basepath + vid_Response[i].converted_videos.hd_mp4;
          // }
        }
        this.videos.push({
          url: vidurl,
          thumb: vid_Response[i].image_cache,
          nid: vid_Response[i].nid,
          title: vid_Response[i].title
        });
      }
      if (window.location.href.indexOf("related-video") > -1) {
        var relid = window.location.pathname.split('/related-video/')[1];
        this.openModal(this.videoTemplate);
        this.openVideoPlayerDesc(relid);
      }
      if (window.location.href.indexOf("/form/") > -1) {
        this.rsvpformopen();
      }
    });

    // this.moreDetailsArray = this.unlServiceService.setMorecontent();
    if (window.location.href.indexOf("MusicAlbum") > -1) {
      if (this.modalRef == undefined)
        this.http.get(
          this.unlServiceService.nodeurl + this.descNID + this.unlServiceService.desc_Page
        ).subscribe(val => {
          this.openmusicplayer('music');
        });
    }
  }
  rsvpformopen() {
    var formname = window.location.pathname.split('/form/')[1];
    if (formname == 'reserve-a-table') {
      this.Btntype = 'Reserve A Table';
    } else if (formname == 'book-a-party') {
      this.Btntype = 'Book A Party';
    } else if (formname == 'rsvp') {
      this.Btntype = 'RSVP';
    }
    if (this.formsTemplate != undefined) {
      //   window.location.reload();
      // }else{
      this.openModal(this.formsTemplate);
    }
  }
  metadatadesc(menuitem) {
    var locname = '';
    if (this.descriptions.location.city != undefined) {
      locname += this.descriptions.location.city + ', ';
    }
    if (this.descriptions.location.province_name != undefined) {
      locname += this.descriptions.location.province_name + ', ';
    }
    locname = locname.slice(0, -2) + ' ';
    if (this.descriptions.type == 'video_live') {
      var metatitle = this.descriptions.title + ' - Live Videos | ' + this.unlServiceService.sitename;
      if (this.descriptions.field_video_keywords[0].value)
        this.metakeys = this.descriptions.field_video_keywords[0].value + ', ' + menuitem.metakeywords;
      else
        this.metakeys = menuitem.metakeywords;
    } else if (this.descriptions.type == 'video1') {
      var metatitle = this.descriptions.title + ' - ' + menuitem.title + ' | ' + this.unlServiceService.sitename;
      if (this.descriptions.field_keywords[0].value)
        this.metakeys = this.descriptions.field_keywords[0].value + ', ' + menuitem.metakeywords;
      else
        this.metakeys = menuitem.metakeywords;
    } else {
      if ($.trim(locname) == '') {
        var metatitle = this.descriptions.title + ' - ' + menuitem.title + ' | ' + this.unlServiceService.sitename;
        this.metakeys = menuitem.metakeywords;
      } else {
        var metatitle = this.descriptions.title + ' - ' + locname + menuitem.title + ' | ' + this.unlServiceService.sitename;
        this.metakeys = locname.replace(/\s/g, '') + menuitem.metakeywords;
      }
    }
    if ($.trim(locname) == '') {
      var metaabs = menuitem.metaabstract;
    } else {
      var metaabs: any = locname + '- ' + menuitem.metaabstract;
    }
    this.currenturl = this.unlServiceService.basepath + this.descriptions.path;
    //this.currenturl = window.location.href.replace('localhost:4200','nightliife.net');
    if (this.descriptions.image_cache_path)
      this.metaimg = this.descriptions.image_cache_path.replace('imagecache/desc_tab/', '');
    else
      this.metaimg = this.descriptions.image_album_path.full[0].replace('imagecache/service_default/', '');
    //this.setCanonicalURL();
    var teaser = this.descriptions.teaser;
    if (teaser != '' && teaser != undefined)
      teaser = this.descriptions.teaser.substring(0, 95) + '...';

    this.title.setTitle(metatitle);
    this.meta.updateTag({ name: 'title', content: metatitle });
    this.meta.updateTag({ property: 'og:title', content: this.descriptions.title });
    this.meta.updateTag({ name: 'twitter:title', content: this.descriptions.title });
    this.meta.updateTag({ name: 'description', content: teaser });
    this.meta.updateTag({ property: 'og:description', content: teaser });
    this.meta.updateTag({ name: 'twitter:description', content: teaser });
    this.meta.updateTag({ name: 'abstract', content: metaabs });
    this.meta.updateTag({ name: 'keywords', content: this.metakeys });
    this.meta.updateTag({ name: 'news_keywords', content: this.metakeys });
    this.meta.updateTag({ property: 'og:url', content: this.currenturl });
    this.meta.updateTag({ name: 'twitter:url', content: this.currenturl });
    this.meta.updateTag({ property: 'og:image', content: this.metaimg });
    this.meta.updateTag({ name: 'twitter:image', content: this.metaimg });
    this.meta.updateTag({ property: 'og:image:width', content: '620' });
    this.meta.updateTag({ property: 'og:image:height', content: '335' });
    this.meta.updateTag({ property: 'og:type', content: 'article' });
    this.meta.updateTag({ name: 'article:content_tier', content: 'free' });
    this.meta.updateTag({ name: 'article:opinion', content: 'false' });
    this.meta.updateTag({ name: 'copyright', content: 'Copyright © ' + (new Date()).getFullYear() + ', Nightlife Media' });
    this.sharebody = encodeURI(this.descriptions.title + ' ' + this.currenturl);
    this.sharelink = encodeURI(this.currenturl);
    this.sharetext = encodeURI(this.descriptions.title);
  }
  
  isSharing = false;

  nativeShare() {
    if (environment.isMoblie) {
      this.ngNavigatorShareService.share({
        title: this.unlServiceService.sitename,
        text: this.descriptions.title,
        url: this.currenturl
      }).then((response) => {
        console.log(response);
        this.isSharing = false; // Re-enable sharing after successful share
      })
        .catch((error) => {
          console.log(error);
          this.isSharing = false; // Re-enable sharing even if an error occurs
        });
    } else {
      this.shareService.updateState(
        {
          title: this.unlServiceService.sitename,
          text: this.descriptions.title,
          url: this.currenturl,
          description: this.descpara1,
          platform: 'all'
        }
      )
    }
  }
  
  nativesharefb() {
    if (this.ngNavigatorShareService.share) {
      this.ngNavigatorShareService
        .share({ title: this.unlServiceService.sitename, url: `${this.currenturl}`, text: `${this.descriptions.title}` })
        .then(() => {
          console.log('Thanks for sharing!');
        })
        .catch(console.error);
    } else {
      window.location.replace(
        `https://www.facebook.com/sharer.php?u=${this.currenturl.trim()}&quote=${this.descriptions.title}`
      );
    }
  }
  // setCanonicalURL(url?: string) {
  //   const canURL = url == undefined ? this.currenturl : url;
  //   const link: HTMLLinkElement = document.createElement('link');
  //   link.setAttribute('rel', 'canonical');
  //   document.head.appendChild(link);
  //   link.setAttribute('href', canURL);
  // }
  urltext(text) {
    text = text.replace('&#039;', '').replace('&amp;', '').replace('&quot;', '');
    text = text.replace(/[&\/\\#,+()$~%!‘’.'":;*?<>@{}-]/g, '');
    return text.replace(/\s+/g, '-').toLowerCase();
  }
  firsturl(url: string) {
    return url.split(",", 1);
  }
  htmlDecode(input) {
    var e = document.createElement('textarea');
    e.innerHTML = input;
    // handle case of empty input
    return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
  }
  setDialJson() {
    return this.http.get(
      "assets/dialingcode.json"
    );
  }
  getDialJson() {
    this.setDialJson().subscribe(Jsondial => {
      this.dialcodeJson = Jsondial;
    })
  }
  openNewTab(ad) {
    this.adContent = ad.clickurl;
    window.open(this.adContent, "_blank");
  }
  openSlideshowDesc(index) {
    this.albumsLightbox = [];
    var position = 0;
    for (var i in this.images) {
      var imgSrc = this.images[i].srcUrl;
      if (index.path)
        if (index.path[0].src.split('service_mobile1/')[1] == imgSrc.split('mobile_photoslide/')[1]) {
          position = parseInt(i);
        }
      const album = {
        src: imgSrc
      };
      this.albumsLightbox.push(album);
    }
    //jQuery.fancybox.defaults.hash =this.descriptions.nid;
    if (position != 0) {
      jQuery.fancybox.open(this.albumsLightbox, { touch: true, animationEffect: "zoom-in-out" }, position);
    } else {
      jQuery.fancybox.open(this.albumsLightbox, { touch: true, animationEffect: "zoom-in-out" });
    }
    $("#fancy-div").append(this.descriptions.title);
  }
  openPopup(txt) {
    jQuery.fancybox.defaults.hash = txt;
    jQuery.fancybox.defaults.infobar = false;
    jQuery.fancybox.defaults.caption = '';
    jQuery.fancybox.defaults.enableEscapeButton = false;
    jQuery.fancybox.defaults.baseTpl = '<div class="fancybox-container" role="dialog" tabindex="-1">' +
      '<div class="fancybox-bg"></div>' +
      '<div class="fancybox-inner">' +
      '<div class="daya container-fluid"><div class="fancybox-infobar infbar"></div>' +
      '<div class="fancybox-toolbar"></div>' +
      '<div class="fancybox-navigation">{{arrows}}</div></div>' +
      '<div class="fancybox-stage"></div>' +
      "</div>" +
      "</div>";
  }
  closeFancypopup(type) {
    jQuery.fancybox.close();
    this.formClose();
    this.rsvpformopen();
  }
  openModal(template: TemplateRef<any>) {
    this.isModalOpen = false;
    this.modalRef = this.modalService.show(template, { class: 'modal-sm modalsizecls' });
    const _combine = combineLatest(
      this.modalService.onShow,
      this.modalService.onShown,
      this.modalService.onHide,
      this.modalService.onHidden
    ).subscribe(() => this.changeDetection.markForCheck());
    this.subscriptions.push(
      this.modalService.onShow.subscribe((reason: string) => {
      })
    );
    this.subscriptions.push(
      this.modalService.onShown.subscribe((reason: string) => {
        this.isModalOpen = false;
      })
    );
    this.subscriptions.push(
      this.modalService.onHide.subscribe((reason: string) => {
        const _reason = reason ? `, dismissed by ${reason}` : '';
        this.isModalOpen = false;
        //window.history.forward();
        // $("#pageloader").fadeOut();
      })
    );
    this.subscriptions.push(
      this.modalService.onHidden.subscribe((reason: string) => {
        const _reason = reason ? `, dismissed by ${reason}` : '';
        this.unsubscribe();
        this.isModalOpen = true;
      })
    );
    this.subscriptions.push(_combine);
  }
  unsubscribe() {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
    this.subscriptions = [];
  }
  closeModal() {
    if (window.location.href.indexOf("/related-video") > -1) {
      var currlink = window.location.pathname.split('/related-video')[0];
      currlink = currlink.substring(1).replace('n/', '');
      this.router.navigateByUrl('/', { skipLocationChange: true })
        .then(succeeded => {
          if (succeeded) {
            this.router.navigate([currlink])
          } else {
            this.location2.go(currlink);
          }
        })
        .catch(error => {
          console.log(error);
        });
      // .then(() => this.router.navigate([currlink]));
      this.pauseVG2();
      // $("#pageloader").fadeOut();
    } else if (window.location.href.indexOf("/play") > -1) {
      var currlink = window.location.pathname.split('/play')[0];
      currlink = currlink.substring(1).replace('n/', '');
      this.router.navigateByUrl('/', { skipLocationChange: true })
        .then(succeeded => {
          if (succeeded) {
            this.router.navigate([currlink])
          } else {
            this.location2.go(currlink);
          }
        })
        .catch(error => {
          console.log(error);
        });
      // .then(() => this.router.navigate([currlink]));
      // $("#pageloader").fadeOut();
    }
    if (this.isLightbxclsd == 'closed') {
      this.lightBoxRef.close();
    }
    if (this.modalRef !== undefined) {
      this.modalRef.hide();
      //window.history.forward();
    }
  }
  formClose() {
    this.formReset();
    if (window.location.href.indexOf("/form/") > -1) {
      var currlink = window.location.pathname.split('/form/')[0].replace('n/', '');
      this.router.navigateByUrl('/', { skipLocationChange: true })
        .then(succeeded => {
          if (succeeded) {
            this.router.navigate([currlink])
          } else {
            this.location2.go(currlink);
          }
        })
        .catch(error => {
          console.log(error);
        });
      // this.location2.go(currlink);
    }
    this.modalRef.hide();
  }
  canDeactivate() {
    return this.isModalOpen;
  }

  ngOnDestroy() {
    this.titleW = 3;
    console.log("Ondestroy");
    if (this.isModalOpen == false) {
      //window.history.forward();
    }
    jQuery(".fancybox").unbind('click.fb');
    this.descsubscription.unsubscribe();
    // or maybe jQuery(".fancybox").off() to remove all bindings
  }
  myFilter = (d: Date): boolean => {
    const day = d.getDay();
    const restriction = this.missing;
    if (this.missing !== undefined) {
      return day !== restriction[0] && day !== restriction[1] && day !== restriction[2] && day !== restriction[3] && day !== restriction[4] && day !== restriction[5] && day !== restriction[6];
    } else {
      return day !== null;
    }
  }
  openVideoPlayerDesc(isBoolean) {
    this.pauseAd = true;
    var currlink = window.location.pathname.substring(1);
    if (typeof isBoolean === "boolean") {
      this.cArr = this.head_Vid;
      this.vidtitle = this.descriptions.title;
      const vidlink = {
        crr: this.cArr,
        title: this.descriptions.title
      }
      if (window.location.href.indexOf("/play") <= -1) {
        this.location2.go(currlink + '/play');
      }
      //this.unlServiceService.getvideodetails(vidlink);
    } else {
      var vidnid = '';
      this.albumsLightbox = [];
      if (!Number.isInteger(isBoolean))
        isBoolean = isBoolean.split('/')[0];
      if (this.api) {
        this.pauseVG();
      }
      this.cArr = this.videos[isBoolean].url;
      vidnid = this.videos[isBoolean].nid;
      this.vidtitle = this.videos[isBoolean].title;
      const vidlink = {
        crr: this.cArr,
        title: this.vidtitle,
        adtagUrl: "https://control-test-ec.adaptv.advertising.com/a/h/XUUFc52Hk6EG5kr_a193yZgOQ3X4tLLdnTWkWvY8K4I=?cb=" + Math.round(new Date().getTime() / 1000) + "&pageUrl=http%3A%2F%2Ftest.com&ctx.pubid=NIGHTLIFE&eov=eov"
      }
      if (window.location.href.indexOf("related-video") <= -1) {
        this.location2.go(currlink.replace('n/', '') + '/related-video/' + isBoolean + '/' + vidnid);
      }
      //this.unlServiceService.getvideodetails(vidlink);
    }
    var vpD = {
      title: this.vidtitle,
      crr: this.cArr,
      vidCatname: '',
      vidpath: window.location.href
    }
    this.unlServiceService.getvideodetails(vpD);
    return this.cArr;
  }
  BtnTypeFn(type) {
    this.Btntype = type.target.defaultValue;
    var currlink = window.location.pathname.substring(1).replace('n/', '');
    if (window.location.href.indexOf("form") <= -1) {
      this.location2.go(currlink + '/form/' + this.urltext(this.Btntype));
    }
  }
  get f() {
    return this.unlRsvpForm1.controls;
  }
  onSubmit() {
    this.submitted = true;
    // TODO: Use EventEmitter with form value
    if (this.unlRsvpForm1.invalid) {
      return;
    } else if (this.unlRsvpForm1.valid) {
      $(".formsubmit").hide();
      if (this.Btntype == "Make Reservation" || this.Btntype == "Reserve A Table")
        $(".rsvpform").append('<div style="color:yellow;"><b>Please wait while we submit your Reservation request <span style="font-size:45px;color:#fff;animation: dots 1s steps(5, end) infinite;line-height:0;"> .</span></b></div>');
      else if (this.Btntype == "Book A Party")
        $(".rsvpform").append('<div style="color:yellow;"><b>Please wait while we submit your Party request <span style="font-size:45px;color:#fff;animation: dots 1s steps(5, end) infinite;line-height:0;"> .</span></b></div>');
      else
        $(".rsvpform").append('<div style="color:yellow;"><b>Please wait while we submit your  ' + this.Btntype + ' request <span style="font-size:45px;color:#fff;animation: dots 1s steps(5, end) infinite;line-height:0;"> .</span></b></div>');
      var dc = this.unlRsvpForm1.get('phone').value.countryCode + '-' + this.unlRsvpForm1.get('phone').value.dialCode;
      var mob = this.unlRsvpForm1.get('phone').value.nationalNumber;
      if (this.unlRsvpForm1.get('node_type').value == "bars" || this.unlRsvpForm1.get('node_type').value == "nightclubs") {
        if (this.Btntype == "Book A Party") {
          this.frmcopy = this.fb.group({
            'field_bap_date[0][value]': [this.dateformat(this.unlRsvpForm1.get('date').value)],
            'field_bap_fname[0][value]': [this.unlRsvpForm1.get('firstName').value],
            'profile_name': [this.unlRsvpForm1.get('firstName').value],
            'field_bap_lname[0][value]': [this.unlRsvpForm1.get('lastName').value],
            'profile_lname': [this.unlRsvpForm1.get('lastName').value],
            'field_bap_email[0][value]': [this.unlRsvpForm1.get('eMail').value],
            'mail': [this.unlRsvpForm1.get('eMail').value],
            'name': [this.unlRsvpForm1.get('firstName').value + '.' + this.unlRsvpForm1.get('lastName').value.substring(0, 1) + '-' + Math.random().toString(36).substr(2, 9)],
            'timezone': -18000,
            'field_bap_cc[0][value]': [dc],
            'field_bap_mobile[0][value]': [mob],
            'field_bap_guests[0][value]': [this.unlRsvpForm1.get('noofGuests').value],
            'field_bap_share[value]': [this.unlRsvpForm1.get('posts').value],
            'field_book_myparty_ref[0][nid]': [this.unlRsvpForm1.get('node_id').value],
            'field_bap_comment[0][value]': [this.unlRsvpForm1.get('comment').value],
            'title': [this.unlRsvpForm1.get('node_title').value + '- Book A Party'],
            'type': 'book_a_party'
          });
        } else if (this.Btntype == "Reserve A Table") {
          this.frmcopy = this.fb.group({
            'field_date_reser[0][value]': [this.dateformat(this.unlRsvpForm1.get('date').value)],
            'field_res_fname[0][value]': [this.unlRsvpForm1.get('firstName').value],
            'profile_name': [this.unlRsvpForm1.get('firstName').value],
            'field_res_lname[0][value]': [this.unlRsvpForm1.get('lastName').value],
            'profile_lname': [this.unlRsvpForm1.get('lastName').value],
            'field_res_email[0][value]': [this.unlRsvpForm1.get('eMail').value],
            'mail': [this.unlRsvpForm1.get('eMail').value],
            'name': [this.unlRsvpForm1.get('firstName').value + '.' + this.unlRsvpForm1.get('lastName').value.substring(0, 1) + '-' + Math.random().toString(36).substr(2, 9)],
            'timezone': -18000,
            'field_res_cc[0][value]': [dc],
            'field_res_mobile[0][value]': [mob],
            'field_res_guests[0][value]': [this.unlRsvpForm1.get('noofGuests').value],
            'field_reser_share[value]': [this.unlRsvpForm1.get('posts').value],
            'field_reservation_ref[0][nid]': [this.unlRsvpForm1.get('node_id').value],
            'field_res_comment[0][value]': [this.unlRsvpForm1.get('comment').value],
            'title': [this.unlRsvpForm1.get('node_title').value + '- Reserve A Table'],
            'type': 'reservation'
          });
        } else {
          this.frmcopy = this.fb.group({
            'field_rsvp_choosedate[0][value]': [this.dateformat(this.unlRsvpForm1.get('date').value)],
            'field_rsvp_fname[0][value]': [this.unlRsvpForm1.get('firstName').value],
            'profile_name': [this.unlRsvpForm1.get('firstName').value],
            'field_rsvp_lname[0][value]': [this.unlRsvpForm1.get('lastName').value],
            'profile_lname': [this.unlRsvpForm1.get('lastName').value],
            'field_rsvp_email[0][value]': [this.unlRsvpForm1.get('eMail').value],
            'mail': [this.unlRsvpForm1.get('eMail').value],
            'name': [this.unlRsvpForm1.get('firstName').value + '.' + this.unlRsvpForm1.get('lastName').value.substring(0, 1) + '-' + Math.random().toString(36).substr(2, 9)],
            'timezone': -18000,
            'field_rsvp_cc[0][value]': [dc],
            'field_rsvp_mobile[0][value]': [mob],
            'field_rsvp_guests[0][value]': [this.unlRsvpForm1.get('noofGuests').value],
            'field_rsvp_postshare[value]': [this.unlRsvpForm1.get('posts').value],
            'field_rsvpref[0][nid]': [this.unlRsvpForm1.get('node_id').value],
            'field_rsvp_comment[0][value]': [this.unlRsvpForm1.get('comment').value],
            'title': [this.unlRsvpForm1.get('node_title').value + '- RSVP'],
            'type': 'rsvp'
          });
        }
      } else if (this.unlRsvpForm1.get('node_type').value == "restaurants") {
        this.frmcopy = this.fb.group({
          'field_date_reser[0][value]': [this.dateformat(this.unlRsvpForm1.get('date').value)],
          'field_res_fname[0][value]': [this.unlRsvpForm1.get('firstName').value],
          'profile_name': [this.unlRsvpForm1.get('firstName').value],
          'field_res_lname[0][value]': [this.unlRsvpForm1.get('lastName').value],
          'profile_lname': [this.unlRsvpForm1.get('lastName').value],
          'field_res_email[0][value]': [this.unlRsvpForm1.get('eMail').value],
          'mail': [this.unlRsvpForm1.get('eMail').value],
          'name': [this.unlRsvpForm1.get('firstName').value + '.' + this.unlRsvpForm1.get('lastName').value.substring(0, 1) + '-' + Math.random().toString(36).substr(2, 9)],
          'timezone': -18000,
          'field_rsvp_cc[0][value]': [dc],
          'field_res_mobile[0][value]': [mob],
          'field_res_guests[0][value]': [this.unlRsvpForm1.get('noofGuests').value],
          'field_reser_share[value]': [this.unlRsvpForm1.get('posts').value],
          'field_reservation_ref[0][nid]': [this.unlRsvpForm1.get('node_id').value],
          'field_res_comment[0][value]': [this.unlRsvpForm1.get('comment').value],
          'title': [this.unlRsvpForm1.get('node_title').value + '- Resevation'],
          'type': 'reservation'
        });
      } else if (this.unlRsvpForm1.get('node_type').value == "hotel") {
        this.frmcopy = this.fb.group({
          'field_chkin_date[0][value]': [this.dateformat(this.unlRsvpForm1.get('date').value)],
          'field_chkout_date[0][value]': [this.dateformat(this.unlRsvpForm1.get('checkout').value)],
          'field_hotb_fname[0][value]': [this.unlRsvpForm1.get('firstName').value],
          'profile_name': [this.unlRsvpForm1.get('firstName').value],
          'field_hotb_lname[0][value]': [this.unlRsvpForm1.get('lastName').value],
          'profile_lname': [this.unlRsvpForm1.get('lastName').value],
          'field_hotb_email[0][value]': [this.unlRsvpForm1.get('eMail').value],
          'mail': [this.unlRsvpForm1.get('eMail').value],
          'name': [this.unlRsvpForm1.get('firstName').value + '.' + this.unlRsvpForm1.get('lastName').value.substring(0, 1) + '-' + Math.random().toString(36).substr(2, 9)],
          'timezone': -18000,
          'field_hotb_cc[0][value]': [dc],
          'field_hotb_mobile[0][value]': [mob],
          'field_hotb_rooms[0][value]': [this.unlRsvpForm1.get('noofGuests').value],
          'field_hotb_reser_share[value]': [this.unlRsvpForm1.get('posts').value],
          'field_hotb_reseref[0][nid]': [this.unlRsvpForm1.get('node_id').value],
          'field_hotb_comment[0][value]': [this.unlRsvpForm1.get('comment').value],
          'title': [this.unlRsvpForm1.get('node_title').value + '- Resevation'],
          'type': 'hotel_booking'
        });
      } else if (this.unlRsvpForm1.get('node_type').value == "transportation") {
        this.frmcopy = this.fb.group({
          'field_trns_date[0][value]': [this.dateformat(this.unlRsvpForm1.get('date').value)],
          'field_trans_fname[0][value]': [this.unlRsvpForm1.get('firstName').value],
          'profile_name': [this.unlRsvpForm1.get('firstName').value],
          'field_trans_lname[0][value]': [this.unlRsvpForm1.get('lastName').value],
          'profile_lname': [this.unlRsvpForm1.get('lastName').value],
          'field_trans_email[0][value]': [this.unlRsvpForm1.get('eMail').value],
          'mail': [this.unlRsvpForm1.get('eMail').value],
          'name': [this.unlRsvpForm1.get('firstName').value + '.' + this.unlRsvpForm1.get('lastName').value.substring(0, 1) + '-' + Math.random().toString(36).substr(2, 9)],
          'timezone': -18000,
          'field_trans_cc[0][value]': [dc],
          'field_trans_mobile[0][value]': [mob],
          'field_trans_passengers[0][value]': [this.unlRsvpForm1.get('noofGuests').value],
          'field_trans_reser_share[value]': [this.unlRsvpForm1.get('posts').value],
          'field_trans_ref[0][nid]': [this.unlRsvpForm1.get('node_id').value],
          'field_trns_comment[0][value]': [this.unlRsvpForm1.get('comment').value],
          'title': [this.unlRsvpForm1.get('node_title').value + '- Resevation'],
          'type': 'transport_reservation'
        });
      } else {
        if (this.unlRsvpForm1.get('posts').value == 'Yes') {
          var posts = 'yes';
        } else {
          var posts = '';
        }
        this.frmcopy = this.fb.group({
          'field_rsvp_date[0][value]': [this.unlRsvpForm1.get('date').value],
          'field_signup_fname[0][value]': [this.unlRsvpForm1.get('firstName').value],
          'profile_name': [this.unlRsvpForm1.get('firstName').value],
          'field_signup_lname[0][value]': [this.unlRsvpForm1.get('lastName').value],
          'profile_lname': [this.unlRsvpForm1.get('lastName').value],
          'field_email[0][value]': [this.unlRsvpForm1.get('eMail').value],
          'mail': [this.unlRsvpForm1.get('eMail').value],
          'name': [this.unlRsvpForm1.get('firstName').value + '.' + this.unlRsvpForm1.get('lastName').value.substring(0, 1) + '-' + Math.random().toString(36).substr(2, 9)],
          'timezone': -18000,
          'field_signup_cc[0][value]': [dc],
          'field_signup_mobile[0][value]': [mob],
          'field_guests[0][value]': [this.unlRsvpForm1.get('noofGuests').value],
          'field_rsvp_share[value]': 'Yes',
          'field_reservation[value]': [posts],
          'field_eventref[0][nid]': [this.unlRsvpForm1.get('node_id').value],
          'field_comment[0][value]': [this.unlRsvpForm1.get('comment').value],
          'title': [this.unlRsvpForm1.get('node_title').value + '- RSVP'],
          'type': 'signup'
        });
      }
      var data = this.frmcopy.value;
      console.log(data);
      data = this.serialize(data);
      var xhr = new XMLHttpRequest();
      var modal = this.modalRef;
      var form = this.unlRsvpForm1;
      xhr.withCredentials = true;
      xhr.addEventListener("readystatechange", function () {
        if (this.readyState === 4 && this.status == 200) {
          alert('YOUR RESERVATION REQUEST HAS BEEN SUBMITTED. Please periodically check Your Email and Mobile Phone for confirmation alerts & instructions.');
          modal.hide();
          var tit = form.get('node_title').value;
          var typ = form.get('node_type').value;
          var nid = form.get('node_id').value;
          form.reset();
          form.get('node_title').setValue(tit);
          form.get('node_type').setValue(typ);
          form.get('node_id').setValue(nid);
        }
      });
      xhr.open("POST", window.location.origin + "/testunl/node.json");
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
      xhr.send(data);
    }
    this.formReset()
  }
  serialize(obj) {
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
  }
  dateformat(date) {
    var d = new Date(date),
      month = d.getMonth() + 1,
      day = d.getDate(),
      year = d.getFullYear();
    return month + '/' + day + '/' + year;
  }
  checkoutdate(dte) {
    return new Date(new Date(dte).getTime() + (60 * 60 * 24 * 1000));
  }
  //scrollablecontent;
  scrollabletop: any = { "top": "100px" };
  //scrollablecontent;
  scrollablecontentH;
  @HostListener("window:load", ["$event"])
  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.getScreenSize();
  }
  getScreenSize() {
    try {
      var wH = $(window).height();
      this.titleW = $("#scrble").height();
      if (this.titleW !== undefined)
        this.scrollablecontentH = this.titleW + 5;
      if (!isNaN(this.scrollablecontentH)) {
        this.scrollabletop = { "top": this.scrollablecontentH + "px" };
        this.screenHeight = { height: (wH + this.scrollablecontentH) + "px" };
        this.loaderH = (wH + this.scrollablecontentH) - 36;
      }
    } catch (e) {
      console.log("this.scrollablecontentH");

    }
    /*setTimeout(function () {
      var wH = $(window).height();
      this.titleW = $("#scrble").outerHeight(true);
      this.scrollablecontentH = this.titleW + 5;
      this.screenHeight = wH - this.searchfix;
      this.loaderH = this.screenHeight - 36;
      if (this.titleW == undefined) {
        this.getScreenSize();
      }
      //$(".ng-sidebar__content").scrollTop(0);
    }.bind(this), 2700);*/
  }
  ngAfterContentInit() {
    this.getScreenSize();
  }
  ngOnChanges(changes: SimpleChanges) {
    console.log("changes |", changes);
  }

  // ngAfterContentChecked(){
  //   this.getScreenSize();
  // }
  ngAfterViewChecked(){
    this.getScreenSize();
  }
  openmusicplayer(type: string) {
   // alert(',,,,');
    this.x = type;
    this.msaapPlaylist = [];
    const taxonomy = this.descriptions.taxonomy;
    const artist:any = Object.values(taxonomy).find((item: any) => item.vid === "27");
    this.descriptions.field_music_file.forEach(element => {
      var musiobj = { "title": "", "link": "" ,"trackImage": '',"artist": ''};
      if (element.data.description) {
        musiobj.title = element.data.description;
      } else {
        musiobj.title = this.descriptions.title;
      }
      musiobj.link = this.unlServiceService.basepath + element.filepath;
      musiobj.trackImage = this.head_Img;
      if(artist) {
        musiobj.artist = artist.name;
       }
      this.msaapPlaylist.push(musiobj);
    });
    const albumName = this.descriptions.title
    this.musicService.updateMusicSub({playlist: this.msaapPlaylist, albumName: albumName});
    this.musicService.updateOpenMusicSub(true);

    this.route.queryParams.subscribe(params => {
      console.log(params.mplayer);
      if(params.mplayer == undefined) {
        this.location2.go(this.location2.path(), 'mplayer=true');
      }
    });
     

    //this.router.navigate(['/musicalbum'], { relativeTo: this.route });
   // this.router.navigate(['z'], { relativeTo: this.route });
  }

  playMusic(musicModal) {
   // this.modalRef = this.modalService.show(musicModal, this.config);
    this.msaapPlaylist = [];
    this.descriptions.field_music_file.forEach(element => {
      var musiobj = { "title": "", "link": "" };
      if (element.data.description) {
        musiobj.title = element.data.description;
      } else {
        musiobj.title = this.descriptions.title;
      }
      musiobj.link = this.unlServiceService.basepath + element.filepath;
      this.msaapPlaylist.push(musiobj);
    });
  }

  closeMusic() {
    //if (window.location.href.indexOf("play") > -1) {
    var currlink = window.location.pathname.split('/MusicAlbum')[0];
    currlink = currlink.substring(1).replace('n/', '');
    this.router.navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([currlink]));
    // $("#pageloader").fadeOut();
    //}
    this.modalRef.hide();
  }
  ngAfterViewInit() {
    // this.getScreenSize();
    var self = this;
    jQuery(document).ready(function () { //Photos Gallery
      jQuery(".fancybox").fancybox({
        openEffect: "elastic",
        closeEffect: "elastic",
        maxWidth: "100%",
      });
      jQuery.fancybox.defaults.arrows = false;
      jQuery.fancybox.defaults.btnTpl.sharebtn = '<button data-fancybox-sharebtn class="share-bttn photoshare"><i class="fas fa-share-alt"></i>Share</button>';
      jQuery.fancybox.defaults.buttons = ['sharebtn', 'slideShow', 'close'];
      jQuery.fancybox.defaults.idleTime = 1000;
      jQuery.fancybox.defaults.infobar = true;
      jQuery.fancybox.defaults.baseTpl = '<div class="fancybox-container" role="dialog" tabindex="-1">' +
        '<div class="fancybox-bg"></div>' +
        '<div class="fancybox-inner">' +
        '<div class="cssd1 container-fluid"><div class="fancybox-infobar infbar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span> <span class="fancybox-div" id="fancy-div"></span></div>' +
        '' +
        '<div class="fancybox-toolbar">{{buttons}}</div>' +
        '<div class="fancybox-navigation">{{arrows}}</div></div>' +
        '<div class="fancybox-stage"></div>' +
        "</div>" +
        "</div>"
      jQuery('body').on('click', '[data-fancybox-sharebtn]', function () {
        self.nativeShare();
      });
      // Custom options
      jQuery('[data-fancybox="images"]').fancybox({
        buttons: [
          'sharebtn', 'slideShow', 'close'
        ],
        idleTime: 1000,
        fullScreen: {
          autoStart: false
        },
        thumbs: {
          autoStart: false
        }
      });
    });
  }
  addimpD(event, adJson, i) {
    var target = event.target || event.srcElement || event.currentTarget;
    this.adImp.push(i);
    this.http.get(adJson.impixels[0]).subscribe(val => {
    });
  }
  countInArray(array, what) {
    var count = 0;
    for (var i = 0; i < array.length; i++) {
      if (array[i] === what) {
        count++;
      }
    }
    return count;
  }
  /*onPlayerReady(api: VgAPI) {
    this.api = api;
    // this.api.getDefaultMedia().subscriptions.ended.subscribe(
    //   () => {
    //     // Set the video to the beginning
    //     this.api.getDefaultMedia().currentTime = 0;
    //   }
    // );
    //var vid = document.getElementsByClassName("vplayer");
    var vid = document.getElementById(api.videogularElement.id);
    // this.api.fsAPI.toggleFullscreen(vid);
    this.api.getDefaultMedia().subscriptions.ended.subscribe(
      () => {
        // Set the video to the beginning
        this.api.getDefaultMedia().currentTime = 0;
      }
    );
    this.subscriptions.push(this.controlsHidden.isHidden.subscribe(this.onHideControls.bind(this)));

    this.api.getDefaultMedia().subscriptions.pause.subscribe(() => {
      this.overLayT = false;
      this.descriptions.overLayT = false;
    })

    this.api.getDefaultMedia().subscriptions.play.subscribe(() => {
      this.overLayT = true;
      this.descriptions.overLayT = true;
    })
    this.api.getDefaultMedia().subscriptions.progress.subscribe(() => {
      this.conPP = false;
      this.descriptions.conPP = false;
    })

    screen.orientation.onchange = function () {
      /* logs 'portrait' or 'landscape' 
      var t = screen.orientation.type.match(/\w+/)[0];
      var elem = document.getElementsByClassName("vplayer");
      function tFullscreen() {
        this.toggleFullScreen()
      }
      try {
        var my: any;
        if (t == "landscape") {
          try {
            window["my"].unlvideo.toggleScrn(true);
          } catch (e) {

          }
        } else if (t == "portrait") {
          window["my"].unlvideo.toggleScrn(false);
        }
      } catch (e) {

      }
    };
  }
  onPlayerReady2(api: VgAPI) {
    this.api2 = api;
    var vid = document.getElementById(api.videogularElement.id);
    this.api2.getDefaultMedia().subscriptions.ended.subscribe(
      () => {
        this.api2.getDefaultMedia().currentTime = 0;
      }
    );
    this.subscriptions.push(this.controlsHidden.isHidden.subscribe(this.onHideControls.bind(this)));

    this.api2.getDefaultMedia().subscriptions.pause.subscribe(() => {
      this.overLayT = false;
      this.descriptions.overLayT = false;
    })

    this.api2.getDefaultMedia().subscriptions.play.subscribe(() => {
      this.overLayT = true;
      this.descriptions.overLayT = true;
      // setTimeout(()=>{ this.overLayT=false}, 4090)
    })
    this.api2.getDefaultMedia().subscriptions.progress.subscribe(() => {
      this.conPP = false;
      this.descriptions.conPP = false;
    })

    screen.orientation.onchange = function () {
      /* logs 'portrait' or 'landscape' 
      var t = screen.orientation.type.match(/\w+/)[0];
      var elem = document.getElementsByClassName("vplayer");
      function tFullscreen() {
        this.toggleFullScreen()
      }
      try {
        var my: any;
        if (t == "landscape") {
          try {
            window["my"].unlvideo.toggleScrn(true);
          } catch (e) {

          }
        } else if (t == "portrait") {
          window["my"].unlvideo.toggleScrn(false);
        }
      } catch (e) {

      }
    };
  }*/
  onPlayerReady(api: VgAPI) {
    this.api = api;
    // console.log(this.api,"Ima",Ima);
    // this.api.getDefaultMedia().subscriptions.ended.subscribe(
    //   () => {
    //     // Set the video to the beginning
    //     this.api.getDefaultMedia().currentTime = 0;
    //   }
    // );
    //var vid = document.getElementsByClassName("vplayer");
    var vid = document.getElementById(api.videogularElement.id);
    // this.api.fsAPI.toggleFullscreen(vid);
    this.api.getDefaultMedia().subscriptions.ended.subscribe(
      () => {
        // Set the video to the beginning
        this.api.getDefaultMedia().currentTime = 0;
      }
    );


    this.api.getDefaultMedia().subscriptions.loadedMetadata.subscribe(
      () => {
        // Set the video to the beginning
        // alert("metadata loaded");
        var mutebutton=document.getElementById("mutevideo");
        this.ismuted=false;
       // mutebutton.click();
        var html='<div aria-label="mute" class="icon vg-icon-volume_up" role="button" tabindex="0" aria-valuetext="unmuted"></div>';
        mutebutton.innerHTML=html;
      }
    );
    this.subscriptions.push(this.controlsHidden.isHidden.subscribe(this.onHideControls.bind(this)));

    this.api.getDefaultMedia().subscriptions.pause.subscribe(() => {
      this.overLayT = false;
      this.descriptions.overLayT = false;
    })

    this.api.getDefaultMedia().subscriptions.play.subscribe(() => {
      this.overLayT = true;
      this.descriptions.overLayT = true;
    })
    this.api.getDefaultMedia().subscriptions.progress.subscribe(() => {
      this.conPP = false;
      this.descriptions.conPP = false;
    })

    screen.orientation.onchange = function () {
      /* logs 'portrait' or 'landscape' */
      var t = screen.orientation.type.match(/\w+/)[0];
      var elem = document.getElementsByClassName("vplayer");
      function tFullscreen() {
        this.toggleFullScreen()
      }
      try {
        var my: any;
        if (t == "landscape") {
          try {
            window["my"].unlvideo.toggleScrn(true);
          } catch (e) {

          }
        } else if (t == "portrait") {
          window["my"].unlvideo.toggleScrn(false);
        }
      } catch (e) {

      }
    };
  }
  onPlayerReady2(api: VgAPI) {
    this.api2 = api;
    var vid = document.getElementById(api.videogularElement.id);
    this.api2.getDefaultMedia().subscriptions.ended.subscribe(
      () => {
        this.api2.getDefaultMedia().currentTime = 0;
      }
    );

    
    this.api.getDefaultMedia().subscriptions.loadedMetadata.subscribe(
      () => {
        // Set the video to the beginning
        // alert("metadata loaded");
        var mutebutton=document.getElementById("mutevideo1");
        this.ismuted1=false;
       // mutebutton.click();
        var html='<div aria-label="mute" class="icon vg-icon-volume_up" role="button" tabindex="0" aria-valuetext="unmuted"></div>';
        mutebutton.innerHTML=html;
      }
    );

    this.subscriptions.push(this.controlsHidden.isHidden.subscribe(this.onHideControls.bind(this)));

    this.api2.getDefaultMedia().subscriptions.pause.subscribe(() => {
      this.overLayT = false;
      this.descriptions.overLayT = false;
    })

    this.api2.getDefaultMedia().subscriptions.play.subscribe(() => {
      this.overLayT = true;
      this.descriptions.overLayT = true;
      // setTimeout(()=>{ this.overLayT=false}, 4090)
    })
    this.api2.getDefaultMedia().subscriptions.progress.subscribe(() => {
      this.conPP = false;
      this.descriptions.conPP = false;
    })

    screen.orientation.onchange = function () {
      /* logs 'portrait' or 'landscape' */
      var t = screen.orientation.type.match(/\w+/)[0];
      var elem = document.getElementsByClassName("vplayer");
      function tFullscreen() {
        this.toggleFullScreen()
      }
      try {
        var my: any;
        if (t == "landscape") {
          try {
            window["my"].unlvideo.toggleScrn(true);
          } catch (e) {

          }
        } else if (t == "portrait") {
          window["my"].unlvideo.toggleScrn(false);
        }
      } catch (e) {

      }
    };
  }
  conH() {    
    this.conPP = true;
    this.descriptions.conPP = true;
    setTimeout(() => { if(this.overLayT) this.conPP = false; this.descriptions.conPP = false; }, 5000)
  }

  MuteAudio(event){
    try{
      var target = event.target || event.srcElement || event.currentTarget;
      console.log("Mutevideoelement");  
      var element=target.children[0];
      var vid = <HTMLVideoElement>document.getElementById("videoautoplay1");
      if(!this.ismuted)
      {
        var html='<div aria-label="mute" class="icon vg-icon-volume_off" role="button" tabindex="0" aria-valuetext="muted"></div>';
        vid.volume=0;
        vid.muted = true;
        this.ismuted=true;
         target.innerHTML=html;
       
      }else{
        vid.volume=1;
        vid.muted = false;
        this.ismuted=false;
        var html='<div aria-label="mute" class="icon vg-icon-volume_up" role="button" tabindex="0" aria-valuetext="unmuted"></div>';
        target.innerHTML=html;
      
      }
    }catch(e){
      alert(e.Message);
    }
  }

  MuteAudio1(event){
    try{
      var target = event.target || event.srcElement || event.currentTarget;
      console.log("Mutevideoelement");  
      var element=target.children[0];
      var vid = <HTMLVideoElement>document.getElementById("videoautoplay");
      if(!this.ismuted1)
      {
        var html='<div aria-label="mute" class="icon vg-icon-volume_off" role="button" tabindex="0" aria-valuetext="muted"></div>';
        vid.volume=0;
        vid.muted = true;
        this.ismuted1=true;
         target.innerHTML=html;
       
      }else{
        vid.volume=1;
        vid.muted = false;
        this.ismuted1=false;
        var html='<div aria-label="mute" class="icon vg-icon-volume_up" role="button" tabindex="0" aria-valuetext="unmuted"></div>';
        target.innerHTML=html;
      
      }
    }catch(e){
      alert(e.Message);
    }
  }
  pauseVG() {
    this.conPP=true;
    this.api.pause();
    //setTimeout(() => { if(!this.overLayT) this.conPP = true; }, 4000);
  }
  playVG() {
    //this.conPP=true;
    this.overLayT=true;
    this.conH();
    this.api.play();
    //setTimeout(() => { if(this.overLayT) this.conPP = false; }, 4000);
  }
  pauseVG2() {
    this.conPP=true;
    this.api2.pause();
  }
  playVG2() {
    this.overLayT=true;
    this.conH();
    this.api2.play();
    //setTimeout(() => { if(this.overLayT) this.conPP = false; }, 4000)
  }
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    event.preventDefault();
  }
  onHideControls(state: boolean) {
    console.log('Are controls hidden?', state);
  }

  @HostListener('window:resize', ['$event'])
  applyOrientation() {
    this.getScreenSize();
    if (window.innerHeight < window.innerWidth) {
      var vid;
      if (this.isModalOpen) {
        vid = document.getElementById("vgp3");
      } else {
        vid = document.getElementsByClassName("vplayer");
      }
      this.isPortrait = false;
    } else if (window.innerHeight > window.innerWidth) {
      this.isPortrait = true;
    }
  }

  setFullScreen(full: boolean): void {
    if (full) {
      if (!this.isFullScreen()) {
        this.toggleFullScreen();
      }
    } else {
      if (this.isFullScreen()) {
        this.toggleFullScreen();
      }
    }
    /*if (full !== this.isFullScreen())
      this.toggleFullScreen();*/
  }
  toggleFullScreen(): void {
    const fsDoc = <FsDocument>document;
    if (!this.isFullScreen()) {
      var fsDocElem;
      if (this.isModalOpen)
        fsDocElem = <FsDocumentElement>document.getElementById("vgp1");
      else {
        fsDocElem = <FsDocumentElement>document.getElementById("vgp3");
      }
      if (fsDocElem.requestFullscreen)
        fsDocElem.requestFullscreen();
      else if (fsDocElem.msRequestFullscreen)
        fsDocElem.msRequestFullscreen();
      else if (fsDocElem.mozRequestFullScreen)
        fsDocElem.mozRequestFullScreen();
      else if (fsDocElem.webkitRequestFullscreen)
        fsDocElem.webkitRequestFullscreen();
    } else {
      if (fsDoc.exitFullscreen)
        fsDoc.exitFullscreen();
      else if (fsDoc.msExitFullscreen)
        fsDoc.msExitFullscreen();
      else if (fsDoc.mozCancelFullScreen)
        fsDoc.mozCancelFullScreen();
      else if (fsDoc.webkitExitFullscreen)
        fsDoc.webkitExitFullscreen();
    }
  }
  isFullScreen(): boolean {
    const fsDoc = <FsDocument>document;
    return !!(fsDoc.fullscreenElement || fsDoc.mozFullScreenElement || fsDoc.webkitFullscreenElement || fsDoc.msFullscreenElement);
  }
  setAutoplay(isMuted: boolean) {
    var vid = <HTMLVideoElement>document.getElementById("videoautoplay");
    if (isMuted) {
      vid.muted = false;
    } else {
      vid.muted = true;
    }
  }
  openNewTab1() {
    var type = this.descriptions.type;
    if (type == 'concert' || type == 'concerts') {
      this.x = this.descriptions.field_concert_reservation[0].value;
    } else if (type == 'event') {
      this.x = this.descriptions.field_event_reservation[0].value;
    } else if (type == 'music') {
      this.x = this.descriptions.field_musics_reservation[0].value;
    } else if (type == 'fashion_store') {
      this.x = this.descriptions.field_store_website[0].value;
    } else if (type == 'fashion') {
      this.x = this.descriptions.field_fashion_reservation[0].value;
    }
    window.open(this.x, "_blank");
  }

  formReset(): void {
        this.unlRsvpForm1.reset({
          date: '',
          firstName: '',
          lastName: '',
          eMail: '',
          phone: undefined,
          noofGuests: '',
          posts: 'Yes',
          comment: '',
          node_id: '',
          node_title: '',
          node_type: ''
      });
  

      this.unlRsvpForm1.markAsPristine();
      this.unlRsvpForm1.markAsUntouched();
      this.frmcopy = this.unlRsvpForm1;
      this.submitted = false;
  }

  splitDescription() {
    this.descpara = this.descpara.replace(/\\/g, '"');
    const words = this.descpara.split(' ');
    if (words.length > 30) {
      this.descpara1 = words.slice(0, 65).join(' ');
      this.descpara1 = this.descpara1 + '...'
      this.descpara2 = words.slice(65).join(' '); 
    } else {
      this.descpara1 = this.descpara; 
    }
  }


  transfromImageUrl(imgUrl: any) : any {
    return imgUrl.replace("mobile_photoslide", "mobile_photoslide");
  }

  closeLoginModal(): void {
    this.isLoginModalOpen = false;
  }

  openLoginModal(): void {
    this.isLoginModalOpen = true;
  }

  addReview(): void {
    if(this.authService.isAuthenticated()) {
      return;
    } else {
      this.openLoginModal();
    }
  }

  addMyFavorites(): void {
    if(this.authService.isAuthenticated()) {
      return;
    } else {
      this.openLoginModal();
    }
  }

  checkMplayer(): void {
    this.route.queryParams.subscribe(params => {
      if(params && params.mplayer === 'true') {
        this.openmusicplayer('music');
      }
    });
  }
  
}

@Injectable()
export class modalClose1 implements CanDeactivate<DescriptionContentComponent>{
  canDeactivate(component: DescriptionContentComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot): Observable<boolean> | boolean {
    if (!component.isModalOpen) {
      component.isModalOpen = true;
      return false
    } else {
      return true;
    }

  }

}
